import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import prefixPath from "../utils/prefixPath";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;
  prefixPathApis = undefined;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
    this.prefixPathApis = new prefixPath(apiEndpoint);
  }

  // using sudo
  getAuthHeaders() {
    return {
      // headers: { Authorization: "Basic c3Vkb0Bmb3hjb25uLmNvbTpzdWRv" },
      headers: {
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXN0ZW1Sb2xlIjoic3VkbyIsImVtdWxhdG9yIjp0cnVlLCJzb3VyY2VFbWFpbCI6InN1ZG9AZm94Y29ubi5jb20iLCJzb3VyY2VOYW1lIjoic3VkbyIsImVtYWlsIjoibHVmZkBob3RtYWlsLmNvbSIsIm5hbWUiOiLpra_lpKsiLCJjbGluaWNSb2xlcyI6W3siY2xpbmljIjoiMTY1MDg2NTU3MSIsImNsaW5pY05hbWUiOiLojYnluL3mtbfos4rlnJgiLCJzdGFmZklEIjoiL3N0YWZmL2x1ZmZAaG90bWFpbC5jb20iLCJyb2xlSUQiOiJhZG1pbiIsInJvbGVOYW1lIjoi6Zmi6ZW3IiwicGVybWlzc2lvbnMiOltdfV0sImFsbGlhbmNlIjoiIiwiaWF0IjoxNjg5MzI3ODk1fQ.qm2ZaR9ggmGfiYIWbkrOdyZX2di37yPLP9PqX-aHY3E",
      },
    };
  }

  getSettingWeb(clinicID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/setting`;
    return httpGet(apiUrl, this.getAuthHeaders());
  }

  async getDocWeb(clinicID, docID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}${docID}`;

    if (docID.includes("/inHospital") && docID.includes("/exam")) {
      const inHospitalID = docID.replace(/\/exam.*$/, "");
      const planDateTime = docID
        .replace(/^.*\/exam\//, "")
        .replace(/\/.*$/, "");
      const executeID = docID.replace(/.*\//, "");

      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&executeID=${executeID}`;
    } else if (docID.includes("/inHospital") && docID.includes("/missionLog")) {
      const inHospitalID = docID.replace(/\/missionLog.*$/, "");
      const planDateTime = docID
        .replace(/^.*\/missionLog\//, "")
        .replace(/\/.*$/, "");

      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/missionLog?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}`;
    }

    let res = await httpGet(apiUrl, this.getAuthHeaders());
    if (res.code === 100000 && res.result) {
      if (docID.includes("/inHospital") && docID.includes("/exam")) {
        const prefix = this.prefixPathApis.getInHospitalImagePrefixPathVer2(
          docID.replace(/\/exam.*$/, ""),
          clinicID
        );
        res.result.examTask.forEach((exam) => {
          exam.files = (exam.files || []).map((file) => {
            if (!file._id.startsWith(prefix)) {
              file._id = `${prefix}/${file._id}`;
            }
            return file;
          });
        });
      } else if (
        docID.includes("/inHospital") &&
        docID.includes("/missionLog")
      ) {
        const prefix = this.prefixPathApis.getInHospitalImagePrefixPathVer2(
          docID.replace(/\/missionLog.*$/, ""),
          clinicID
        );
        res.result.execute.forEach((executeLog) => {
          executeLog.attachmentFile = (executeLog.attachmentFile || []).map(
            (file) => {
              if (!file._id.startsWith(prefix)) {
                file._id = `${prefix}/${file._id}`;
              }
              return file;
            }
          );
        });
      } else {
        this.prefixPathApis.prependRecordResourcePath([res.result], clinicID);
      }
    }
    return res;
  }

  uploadRecordImgWeb(_id, upload, clinicID, logID, taskID = null) {
    // console.log(clinicID, _id, logID, taskID);
    let photoData = new FormData();
    if (logID == "avatar") {
      // for avatar
      photoData.append("photo", upload);
    } else {
      Object.keys(upload).forEach((key) => {
        photoData.append(key, upload[key]);
      });
    }

    // 預設上傳病歷檔案
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}${_id}/file`;

    if (logID) {
      if (logID == "avatar") {
        // 上傳寵物大頭照
        apiUrl = `${
          this.apiEndpoint
        }/api/sdk/v2/${clinicID}/pet/${Crypto.encrypt(_id, CryptoKey)}/avatar`;
      } else if (logID.includes("/inHospital") && logID.includes("/exam")) {
        const inHospitalID = logID.replace(/\/exam.*$/, "");
        const planDateTime = logID
          .replace(/^.*\/exam\//, "")
          .replace(/\/.*$/, "");
        const executeID = logID.replace(/^.*\//, "");
        apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/file/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&executeID=${executeID}`;
      } else if (
        logID.includes("/inHospital") &&
        logID.includes("/missionLog")
      ) {
        const inHospitalID = logID.replace(/\/missionLog.*$/, "");
        const planDateTime = logID
          .replace(/^.*\/missionLog\//, "")
          .replace(/\/.*$/, "");
        apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/file/mission?inHospitalID=${inHospitalID}&executeID=${taskID}&planDateTime=${planDateTime}`;
      }
    }
    if (taskID && !logID) {
      apiUrl += `/${taskID}`;
    }

    // console.log(apiUrl);
    return httpUploadFormData(apiUrl, photoData, this.getAuthHeaders());
  }

  uploadFormFileWeb(docID, upload, clinicID) {
    let formData = new FormData();
    Object.keys(upload).forEach((key) => {
      formData.append(key, upload[key]);
    });

    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/form/${Crypto.encrypt(docID, CryptoKey)}/file`;
    return httpUploadFormData(apiUrl, formData, this.getAuthHeaders());
  }

  uploadERPFormFileWeb(formID, upload, clinicID) {
    let formData = new FormData();
    Object.keys(upload).forEach((key) => {
      formData.append(key, upload[key]);
    });

    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/form/${Crypto.encrypt(formID, CryptoKey)}/erpfile`;
    return httpUploadFormData(apiUrl, formData, this.getAuthHeaders());
  }

  deleteRecordImgWeb(_id, delFileNames, clinicID, logID, taskID, action) {
    // console.log(_id, clinicID, logID);
    delFileNames = delFileNames.map((fileName) =>
      fileName.replace(/^.*\//g, "")
    );

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}${_id}/file`;
    if (logID && logID.includes("/exam")) {
      const inHospitalID = logID.replace(/\/exam.*$/, "");
      const planDateTime = logID
        .replace(/^.*\/exam\//, "")
        .replace(/\/.*$/, "");
      const executeID = logID.replace(/^.*\//, "");

      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/file/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&executeID=${executeID}`;
    } else if (logID && logID.includes("/missionLog")) {
      const inHospitalID = logID.replace(/\/missionLog.*$/, "");
      const planDateTime = logID
        .replace(/^.*\/missionLog\//, "")
        .replace(/\/.*$/, "");
      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/file/mission?inHospitalID=${inHospitalID}&executeID=${taskID}&planDateTime=${planDateTime}`;
    } else if (action == "formFile") {
      apiUrl = `${
        this.apiEndpoint
      }/api/sdk/v2/${clinicID}/form/${Crypto.encrypt(_id, CryptoKey)}/erpfile`;
    }

    return httpDelete(apiUrl, delFileNames, this.getAuthHeaders());
  }
}
